/* eslint no-useless-concat: 0 */
/* eslint no-useless-concat: 0 */
/* eslint no-unused-vars: 0 */

import React, { Component } from "react";
import PageTitle from "../../Theme/PageTitle/index.js";
import DashboardLayout from "../../Theme/DashboardLayout/index.js";
import { Modal } from "antd";
import GanttChartTimeline, {
  TimelineHeaders,
  SidebarHeader,
  TimelineMarkers
} from 'react-calendar-timeline' // new
// import 'react-calendar-timeline/lib/Timeline.css'
import containerResizeDetector from 'react-calendar-timeline';
import './ScheduleView.scss'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import timezone from 'dayjs/plugin/timezone.js'
dayjs.extend(utc);
dayjs.extend(timezone);
import groupRendererPosted from '../utils/groupRendererPosted.js';
import generateGroups from './utils/generate-timeline/generateGroups.js';
import generateItems from './utils/generate-timeline/generateItems.js';
import Spinner from '../../Theme/Spinner/index.js';
import CustomPrimaryDateHeader from './CustomPrimaryDateHeader.js';
import CustomDateHeader from './CustomDateHeader.js';
import generateItemDetails from './utils/generateItemDetails.js';
import ItemModalDetails from './ItemModalDetails.js';
import { bindActionCreators } from "redux";
import * as postedScheduleActions from '../../../redux/actions/postedScheduleActions.js';  // TODO: remove dispatch / action from this component
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import lodash from 'lodash';
const { cloneDeep } = lodash;

const scheduleType = 'postedSchedule';

/**
 * Displays the one to two day schedule. When the component is first called it uses redux to call the api to get the
 * data from the database. It then calls generateItems and generateResources to correctly format the data it recieves from the api.
 * After the data has beeen formatted correctly it displays the information.
 */
class PostedScheduleView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      widescreen: false,
      resource: '',
      postedSchedule: '',
      resources: '',
      tours: '',
      startDate: '',
      scheduleFormat: '',
      itemModal: false,
      itemDetails: '',
      tourModalDisplay: '',
      backRedirect: ''
    };
  }


  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
    this.customBrowserBackNavigation();
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.location;
      console.log('pathname:', pathname); // debug
      if (pathname === '/posted-schedule-view-long') {
        this.setState({
          backRedirect: '/posted-schedules'
        });
      }
    };
  };


  readyApiCall = async () => {
    let resource = {
      id: this.props.resource.id || this.props.user.login.resourceId,
      name: this.props.resource.name || this.props.user.userDemographics.name
    }

    if (this.props.location.state) {  // redirected from PostedSchedulesPage with props
      const { startDate, scheduleFormat, postedId } = this.props.location.state;
      await this.props.actions.updatedPostedScheduleParameters({
        startDate,
        scheduleFormat,
        postedId,
        resourceId: resource.id,
        resourceName: resource.name
      })

      this.getDataFromApi(resource, startDate, scheduleFormat, postedId);

    } else { // on page refresh, pull postedSchedule from local storage
      let params = cloneDeep(this.props.postedScheduleParameters);

      const { startDate, scheduleFormat, postedId } = params;
      this.getDataFromApi(resource, startDate, scheduleFormat, postedId);
    }
  }

  getDataFromApi = async (resource, startDate, scheduleFormat, postedId) => {

    await this.props.actions.fetchPostedSchedules(
      startDate,
      scheduleFormat,
      postedId,
      resource.id,
      resource.name
    ).catch(error => {
      alert("Loading posted schedules failed" + JSON.stringify(error));
    });
    this.setState({
      postedSchedule: await this.props.postedSchedule
    }, async () => {
      if (this.state.postedSchedule.resourceCollectionId) {
        await this.props.actions.fetchResourceCollectionInformation({ resourceCollectionId: this.state.postedSchedule.resourceCollectionId }).catch(error => {
          alert("Loading resource collection information failed" + JSON.stringify(error));
        });
      }
      this.setState({
        startDate,
        scheduleFormat,
        tours: generateItems(this.state.postedSchedule.postedSchedule, startDate, scheduleType, scheduleFormat),
        resources: generateGroups(this.state.postedSchedule.postedSchedule),
        resourceCollectionName: this.props.resourceCollectionInfo.name || ''
      });
    });
  }

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  handleItemClick = async (item) => {
      let itemDetails = await generateItemDetails(item, this.state, 'postedSchedule');
      if (itemDetails) {  // i.e. do nothing if its a blank item
        this.setState({
          itemModal: true,
          itemDetails
        });
      }
    
  }

  handleModalCancel = (e) => {
    this.setState({
      itemModal: false,
    });
  }

  formatSubtitle = () => {
    let startDate = dayjs(this.state.postedSchedule.startDate).tz('America/New_York').format('MM/DD/YYYY') || null;
    let savedDate = dayjs(this.state.postedSchedule.savedDate).tz('America/New_York').format('MM/DD/YYYY hh:mm a') || null;
    let userName = this.state.postedSchedule.userName || null;
    let resourceCollectionName = this.props.resourceCollectionInfo.name || null;

    if (startDate && savedDate && userName && resourceCollectionName) {
      return `Posting for ${resourceCollectionName} on ${startDate}. Posted on ${savedDate} by ${userName}`;
    }

    return '';
  }

  render() {
    console.log(this.state.postedSchedule) // debug
    console.log('backRedirect:', this.state.backRedirect); // debug
    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/schedules');
      this.props.navigate(this.state.backRedirect);
    }

    if (this.state.resources && this.state.tours && window.innerWidth) {
      return (
        <DashboardLayout>
          <PageTitle title={'Posted Schedule'}
            subTitle={this.formatSubtitle()} />

          <GanttChartTimeline
            groups={this.state.resources}
            items={this.state.tours}
            visibleTimeStart={dayjs(this.state.startDate).startOf('day')} 
            visibleTimeEnd={dayjs(this.state.startDate).add(this.state.scheduleFormat, 'day')}
            groupRenderer={groupRendererPosted}
            sidebarWidth={120}  // defaults to 150
            resizeDetector={containerResizeDetector} // prevents blank rightSideBar
            itemRenderer={({ item, timelineContext, itemContext, getItemProps, getResizeProps }) => {
              const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();

              const itemProps = getItemProps({
                    onMouseDown: () => {
                      console.log("on item click", item);
                    },
                    onMouseUp: () => {
                      this.handleItemClick(item);
                    },
                    onTouchStart: () => { // Used to select item in chrome mobile.
                      this.handleItemClick(item);
                    }
                  });

              const { background: _bg, ...libStyle } = itemProps.style;

              const finalStyle = {
                ...libStyle,
                backgroundColor: item.backgroundColor,
                color: item.color || "white",
                borderColor: itemContext.selected ? "gold" : (item.borderColor || ""),
                borderStyle: item.borderStyle || "solid",
                borderWidth: itemContext.selected ? 2 : 2,
                borderRadius: 2,
                borderLeftWidth: itemContext.selected ? 3 : 1,
                borderRightWidth: itemContext.selected ? 3 : 1,
              };

              return (
                <div
                  {...itemProps}
                  style={finalStyle}
                >
                  {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

                  <div
                    style={{
                      height: itemContext.dimensions.height,
                      overflow: "hidden",
                      paddingLeft: 3,
                      textOverflow: "string",
                      fontSize: 10,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {itemContext.title}
                  </div>

                  {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                </div>
              );
            }}
            stackItems={true}
            itemHeightRatio={1}
            canMove={false}
            canResize={false}
            fixedHeader={false}
          >
            <TimelineHeaders
              style={{
                position: "sticky",
                top: 0,
                zIndex: 100
              }}
            >
              <SidebarHeader>
                {({ getRootProps }) => {
                  return <div {...getRootProps()}>
                    {/* width must match sidebarWidth */}
                    <h6 style={{ width: 120 }} className="rct-dateHeader-primary">Resource</h6></div>
                }}
              </SidebarHeader>

              < CustomPrimaryDateHeader
                unit="week"
                textAlign="center"
                widescreen={this.state.widescreen}
              />

              < CustomDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />

            </TimelineHeaders>
            <TimelineMarkers>
              {/* <DayMarkers startDate={this.state.startDate}/> */}
            </TimelineMarkers>
          </GanttChartTimeline>
          <Modal
            zIndex={2000}
            title={this.state.itemDetails.title}
            open={this.state.itemModal}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[
              // <Button key="back" onClick={this.handleModalCancel}>Cancel</Button>,
              // <Button key="submit" type="submit" onClick={this.handleSearch}>
              //     Search
              // </Button>,
            ]}
          >
            <ItemModalDetails
              itemDetails={this.state.itemDetails}
              scheduleType={'postedSchedule'}
              securityLevels={this.props.user.securityLevels}
            />

          </Modal>

        </DashboardLayout>
      )
    } else return <Spinner />
  }
}

PostedScheduleView.propTypes = {
  actions: PropTypes.object.isRequired,
  postedSchedule: PropTypes.object.isRequired,
  hamburgerMenu: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    postedSchedule: state.postedSchedules,
    resource: state.selectedResource,
    user: state.user,
    hamburgerMenu: state.navigation.hamburgerMenu,
    resourceCollectionInfo: state.resourceCollectionInformation,
    postedScheduleParameters: state.postedScheduleParameters,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchPostedSchedules: bindActionCreators(
        postedScheduleActions.fetchPostedSchedules,
        dispatch
      ),
      fetchResourceCollectionInformation: bindActionCreators(
        postedScheduleActions.fetchResourceCollectionInformation,
        dispatch
      ),
      updatedPostedScheduleParameters: bindActionCreators(
        postedScheduleActions.updatePostedScheduleParameters,
        dispatch
      ),
    }
  };
}

export const withRouter = (Component) => {
	const Wrapper = (props) => {
		const navigate = useNavigate();
    const location = useLocation();
		return <Component navigate={navigate} {...props} location={location} />;
	};
	return Wrapper;
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostedScheduleView));
